export enum FatcaManagerCompanyRelation {
    ENTITY_OWNERSHIP = '1G',
    ENTITY_OTHER_MEANS = '2G',
    ENTITY_HIGH_OFFICE = '3G',
    TRUSTOR_SETTLOR = '4G',
    TRUSTOR_FIDUCIARY = '5G',
    TRUSTOR_PROTECTOR = '6G',
    TRUSTOR_BENEFICIARY = '7G',
    TRUSTOR_OTHER = '8G',
    INSTRUMENT_SETTLOR = '9G',
    INSTRUMENT_FIDUCIARY = 'AG',
    INSTRUMENT_PROTECTOR = 'BG',
    INSTRUMENT_BENEFICIARY = 'CG',
    INSTRUMENT_OTHER = 'DG'
}
